import {HTTP_STATUS_CONFLICT, HTTP_STATUS_METHOD_NOT_ALLOWED, httpClient} from '../../../infrastructure/HttpClient';
import {Metadata} from '../models/Metadata';
import {handleHttpStatusCode} from '../../../infrastructure/HandleHttpStatusCode';

const removeDoubleDoubleQuotes = (text) => {
  return text.substr(1, text.length - 2);
}

// TODO: can be removed after 1.1.2022 as new calculations no longer have multiple strategies see https://id-jira.axelspringer.de/browse/NCC-2548 for details
export const resolutionStrategyLiteral = (strategy) => {
  switch (strategy) {
    case 'BY_DAM':
      return '(via DAM)';
    case 'BY_VENDOR':
      return '(via Anbieter)';
    default:
      return '';
  }
}

class AssetService {
  static URL_MAPPING = '/usage-catalog/api/assets';

  fetchMetadata(asset) {
    return httpClient
      .get(`${AssetService.URL_MAPPING}/dam/${asset.assetId.dam}/asset/${asset.assetId.damAssetId}/metadata`)
      .then(response => {
        return {
          version: removeDoubleDoubleQuotes(response.headers.etag),
          metadata: Metadata.fromJson(response.data)
        }
      })
  }

  getAssetThumbnailUrl(assetId){
    return httpClient
      .get(`${AssetService.URL_MAPPING}/dam/${assetId.dam}/asset/${assetId.damAssetId}/metadata/thumbnailUrl`)
      .then(response => {
        return response.data
      })
  }

  refreshMetadata(assetId, version) {
    return httpClient
      .post(`${AssetService.URL_MAPPING}/dam/${assetId.dam}/asset/${assetId.damAssetId}/metadata/${assetId.purchaseOrdinal}`, "",{headers: {'If-Match': version}})
      .catch(response => {
        return Promise.reject(
          {
            version: response.headers.etag,
            metadata: Metadata.fromJson(response.data),
            isConflict: response.statuscode === HTTP_STATUS_CONFLICT,
            isNotAllowed: response.statuscode === HTTP_STATUS_METHOD_NOT_ALLOWED
          })
      })
  }

  setRestrictionNote(assetId) {
    return httpClient
      .put(`${AssetService.URL_MAPPING}/dam/${assetId.dam}/asset/${assetId.damAssetId}/restrictionNote`)
  }

  overrideVendor(assetId, vendor) {
    return httpClient
      .post(`${AssetService.URL_MAPPING}/dam/${assetId.dam}/asset/${assetId.damAssetId}/vendor`, vendor)
  }

  updateObjectDescription(assetId, objectDescription) {
    return httpClient
      .put(`${AssetService.URL_MAPPING}/dam/${assetId.dam}/asset/${assetId.damAssetId}/objectDescription`, objectDescription)
      .then(handleHttpStatusCode);
  }

}

export const assetService = new AssetService();
